import { motion, Variants } from "framer-motion";
import { Box } from "../Box";
import { CheckBoxPill } from "../CheckboxPill";
import { Divider } from "../Divider";
import { FlexContainer, FlexItem } from "../Flex";
import { Text } from "../Text";

interface SearchFiltersProps {
  dateState: any;
  themeState?: any;
  onDatesChange: React.ChangeEventHandler<HTMLInputElement>;
  onThemesChange: React.ChangeEventHandler<HTMLInputElement>;
}

const wrapperVariants: Variants = {
  initial: { height: 0 },
  animate: {
    height: "auto",
    transition: { duration: 0.2, staggerChildren: 0.1, when: "beforeChildren" },
  },
  exit: {
    height: 0,
    transition: {
      duration: 0.2,
      staggerDirection: -1,
      staggerChildren: 0.1,
      when: "afterChildren",
    },
  },
};

const innerVariants: Variants = {
  initial: { opacity: 0, x: -40 },
  animate: { opacity: 1, x: 0, transition: { duration: 0.2, ease: "easeOut" } },
  exit: { opacity: 0, x: 40, transition: { duration: 0.2, ease: "easeOut" } },
};

export const SearchFilters: React.FC<SearchFiltersProps> = ({
  dateState,
  themeState,
  onDatesChange,
  onThemesChange,
}) => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={wrapperVariants}
    >
      <Box pt={4} pb={[null, null, null, 2]}>
        <FlexContainer m={-2}>
          <FlexItem flex={["0 0 50%"]} p={2}>
            <motion.div variants={innerVariants}>
              <Text>Browse by year</Text>
              <FlexContainer as="ul" flexWrap="wrap" m={-2}>
                {dateState.map((dateRange: any) => (
                  <FlexItem as="li" key={dateRange.key} p={2}>
                    <CheckBoxPill
                      name="year"
                      color={dateRange.color}
                      value={dateRange.key}
                      onChange={onDatesChange}
                      checked={dateRange.checked}
                    >
                      {dateRange.label}
                    </CheckBoxPill>
                  </FlexItem>
                ))}
              </FlexContainer>
            </motion.div>
          </FlexItem>
          <FlexItem flex={"0 0 50%"} p={2}>
            <motion.div variants={innerVariants}>
              <Text>Browse by themes</Text>

              <FlexContainer as="ul" flexWrap="wrap" m={-2}>
                {themeState.map((category: any) => (
                  <FlexItem as="li" key={category.key} p={2}>
                    <CheckBoxPill
                      name="categories"
                      color={category.color}
                      value={category.key}
                      onChange={onThemesChange}
                      checked={category.checked}
                    >
                      {category.label}
                    </CheckBoxPill>
                  </FlexItem>
                ))}
              </FlexContainer>
            </motion.div>
          </FlexItem>
        </FlexContainer>
        <Box mt={4}>
          <Divider />
        </Box>
      </Box>
    </motion.div>
  );
};
